import { render, staticRenderFns } from "./SwiperCherk.vue?vue&type=template&id=4e597068&scoped=true&"
import script from "./SwiperCherk.vue?vue&type=script&lang=js&"
export * from "./SwiperCherk.vue?vue&type=script&lang=js&"
import style0 from "./SwiperCherk.vue?vue&type=style&index=0&id=4e597068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e597068",
  null
  
)

export default component.exports